import { drag } from 'd3-drag'
import { select } from 'd3-selection'

import { Plugin } from '../entities/plugin'
import type { AbstractNode } from '../types'
import { EVENT_NAME } from '../types'

export interface DragNodeOptions {
  nodeDraggable?: boolean
}

export const DragNode = Plugin.create<
  DragNodeOptions,
  {
    startX?: number
    startY?: number
    isLayout: boolean
  }
>({
  name: 'drag-node',
  addOptions() {
    return {
      nodeDraggable: false,
    }
  },
  addStorage() {
    return {
      isLayout: true,
    }
  },
  onAfterLayout() {
    this.setStorage({
      isLayout: false,
    })
  },
  onBeforeLayout() {
    this.setStorage({
      isLayout: true,
    })
  },
  onNodeMount(event, graph) {
    const { id, element } = event.item as AbstractNode

    if (element) {
      const dragBehavior = drag<HTMLElement | SVGElement, unknown>()
        .on('start', (event) => {
          if (this.options.nodeDraggable === false) {
            return
          }

          this.setStorage({
            startX: event.x,
            startY: event.y,
          })

          element.style.cursor = 'move'

          graph.emitElementEvent(EVENT_NAME.dragstart, event.sourceEvent)
        })
        .on('drag', (event) => {
          if (this.options.nodeDraggable === false) {
            return
          }

          graph.service.send({
            type: 'LIFT_NODE',
            data: {
              id: id,
              type: 'ADD',
              x: event.dx,
              y: event.dy,
            },
          })

          graph.emitElementEvent(EVENT_NAME.drag, event.sourceEvent)
        })
        .on('end', (event) => {
          element.style.cursor = 'default'
          graph.emitElementEvent(EVENT_NAME.dragend, event.sourceEvent)
        })

      select(element).call(dragBehavior)
    }
  },
})
